// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1jY27","list":"PatternAutocomplete_list__Rl9ah"};